export default "__VITE_ASSET__DEw2PRt9__"